import React from "react";
import youtube from "../../assets/youtube.svg";
import telegram from "../../assets/telegram.svg";
import whatsapp from "../../assets/whatsapp.svg";
import play from "../../assets/play.svg";
import gmail from "../../assets/gmail.svg";
import facebook from "../../assets/facebook.svg";
import captureLink from "../../utils/captureLinks";

function Footer() {
  const handleLinkClick = (url, text) => {
    const linkData = {
      page: window.location.pathname,
      url,
      text,
    };
    captureLink(linkData);
  };

  return (
    <footer className="bg-gray-900 text-white py-8 px-6 md:px-12 lg:px-16 xl:px-20">
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-8">
        {/* Company Section */}
        <div>
          <h5 className="text-lg font-semibold mb-4">Company</h5>
          <ul className="space-y-2">
            {[
              { href: "/about-us", text: "About Us" },
              { href: "/privacy-policy", text: "Privacy Policy" },
              { href: "/terms-and-condition", text: "Terms & Conditions" },
              { href: "/refund-policy", text: "Refund Policy" },
              { href: "/contact-us", text: "Contact Us" },
              { href: "/sitemap", text: "Sitemap" },
            ].map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white no-underline hover:text-gray-400 transition"
                  onClick={() => handleLinkClick(item.href, item.text)}
                >
                  {item.text}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Explore Section */}
        <div>
          <h5 className="text-lg font-semibold mb-4">Explore</h5>
          <ul className="space-y-2">
            {[
              {
                href: "https://testportal.ssccglpinnacle.com",
                text: "Test Portal",
              },
              { href: "/", text: "Typing" },
              { href: "https://books.ssccglpinnacle.com", text: "Books" },
              { href: "https://videos.ssccglpinnacle.com", text: "Videos" },
              { href: "https://ebooks.ssccglpinnacle.com", text: "E-Books" },
              { href: "https://blogs.ssccglpinnacle.com/", text: "Blogs" },
            ].map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white no-underline hover:text-gray-400 transition"
                  onClick={() => handleLinkClick(item.href, item.text)}
                >
                  {item.text}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Connect Section */}
        <div>
          <h5 className="text-lg font-semibold mb-4">Connect</h5>
          <ul className="space-y-3">
            {[
              {
                href: "https://www.youtube.com/@pinnaclepublications",
                text: "YouTube",
                img: youtube,
              },
              {
                href: "https://t.me/ssccglpinnacleonline",
                text: "Telegram",
                img: telegram,
              },
              {
                href: "https://whatsapp.com/channel/0029VaFZ5QTC6ZvcTFgbMe2J",
                text: "WhatsApp",
                img: whatsapp,
              },
              {
                href: "https://www.facebook.com/Pinnacle-SSC-Coaching-676467975776244/timeline",
                text: "Facebook",
                img: facebook,
              },
              {
                href: "https://play.google.com/store/apps/details?id=com.ssccgl.pinnacle.testportal",
                text: "Download App",
                img: play,
              },
              {
                href: "mailto:support@ssccglpinnacle.com",
                text: "support@ssccglpinnacle.com",
                img: gmail,
              },
            ].map((item) => (
              <li key={item.href} className="flex items-center space-x-2">
                <img src={item.img} alt={item.text} className="w-6 h-6" />
                <a
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white no-underline hover:text-gray-400 transition"
                  onClick={() => handleLinkClick(item.href, item.text)}
                >
                  {item.text}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Newsletter & Extra Section */}
        {/* <div className="hidden lg:block">
          <h5 className="text-lg font-semibold mb-4">Stay Updated</h5>
          <p className="text-gray-400 text-sm mb-4">
            Subscribe to our newsletter for latest updates.
          </p>
          <input
            type="email"
            placeholder="Enter your email"
            className="w-full p-2 border rounded bg-gray-800 text-white"
          />
          <button className="mt-3 w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition">
            Subscribe
          </button>
        </div> */}
      </div>

      {/* Bottom Section */}
      <div className="w-full flex flex-col md:flex-row items-center mt-10 justify-space-between gap-2">
        <a
          href="//www.dmca.com/Protection/Status.aspx?ID=8feaa748-b020-470b-818e-bdc805e95292"
          title="DMCA.com Protection Status"
          className="dmca-badge"
        >
          <img
            src="https://images.dmca.com/Badges/dmca_protected_sml_120m.png?ID=8feaa748-b020-470b-818e-bdc805e95292"
            alt="DMCA.com Protection Status"
          />
        </a>

        <div className="text-center text-gray-400  text-sm md:ml-70 text-gray-400 ">
          Copyright © 2025 Pinnacle Publications | All Rights Reserved
        </div>
      </div>
    </footer>
  );
}

export default Footer;
